'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { Reference } from '@eliadmin/core/src/api/references/references-types';

export const CustomReferencesSwiper = ({ references }: { references: Reference[] }) => {
  return (
    <>
      <Swiper
        slidesPerView={'auto'}
        spaceBetween={16}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className={cn('mySwiper', 'ea-custom-references__swiper')}
      >
        {references[0]?.images?.map((swipe, index) => (
          <SwiperSlide key={index} className={cn('', 'ea-custom-references__swiper-slide')}>
            <Image
              src={swipe?.url ?? '/images/placeholder.png'}
              alt={resolveImageAlt(swipe, "Referencia")}
              fill
              style={{ objectFit: 'cover', objectPosition: 'center' }}
              sizes="325px"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};
